import React, { Suspense } from "react";

import { Route } from 'react-router-dom';
import { Loader, Message } from 'semantic-ui-react'

import Header from 'xAppLib/UIelems/Header'
import SideMenu from 'xAppLib/MenuNav/SideMenu'
import Footer from 'xAppLib/UIelems/Footer'
import Confirm from 'xAppLib/UIelems/Confirm'

import Popups from 'xAppLib/UIelems/Popups'
// import IdleScreen from 'views/UIelems/IdleScreen'

import MessageBar from 'xAppLib/UIelems/MessageBar'

import Routes, { ProfileRoute } from "Routes";
import Troubleshoot from 'views/UIelems/Troubleshoot'
import SupportActions from 'views/UIelems/SupportActions'
// import Prescs from 'views/prescs/Prescs'
import Logo from 'views/UIelems/Logo'
// import waitFor from 'xAppLib/libs/waitFor'
import AccountOnboarding from "xAppLib/UIelems/AccountOnboarding";
// import MFA from "xAppLib/UIelems/MFA";
// import Alert from "views/NUI/Alert";
// import AwaitingConsults from "./views/instcons/AwaitingConsults";
// import {InstConsWrNotifier} from "./views/instcons/InstConsWrNotifier";
// import WatchApprovals from "views/instcons/WatchApprovals";
// import WatchUnseenResults from "views/instcons/WatchUnseenResults"
// import WatchUnseenResultsExpress from "views/instcons/WatchUnseenResultsExpress"
// import WatchExprCons from "views/instcons/WatchExprCons";

import moment from 'moment'
import { AssertiveRtdbBounce } from "./views/instcons/AssertiveRtdbBounce";
// import { InProgressVideoConsults } from "./views/instcons/InProgressVideoConsults";
// import SMSVerification from "./xAppLib/UIelems/SMSVerification";

// import { FirebaseDynamicLinks } from '@ionic-native/firebase-dynamic-links';


export default class Page extends React.Component {

	constructor (props) {
		super(props)
		this.state = {}

	}
	
	componentDidMount() {
		
		if (app.settings.is_ionic) {
			document.body.classList.add('ionic')
		}

		// Force update to refresh the value of app.acl.is_blocked
		app.on(app.events.CONSENT_UPD, () => this.forceUpdate());
	}

	//	------------------------	------------------------	------------------------
	
	onToggleMenu = (showMenu) => {
		this.setState({showMenu})
	}
	
	

	//	------------------------	------------------------	------------------------

	render() {

		const now_open = moment().tz("Australia/Melbourne").format('H')*1 >= 6 || moment().tz("Australia/Melbourne").format('H')*1 < 3

		return  <React.Fragment>
					
					{!app.settings.is_bare &&
						<SideMenu showMenu={this.state.showMenu} onMenuChange={this.onToggleMenu} />
					}
					
					<div id='page-wrap'>
						
						<Header onToggleMenu={this.onToggleMenu}/>
						
						<main>
							<MessageBar hide_on={[app.runtime?.login_type=='popup'&&'user_auth_msg']} />
							<AccountOnboarding />
							{/*<MFA bannerMode />*/}
							<Suspense fallback={<div className="suspense-style"><Loader active inline /></div>}>
								<Routes />
								{/*{ !app.acl.is_blocked ? <Routes /> : app.user.is_mfa_blocked && <ProfileRoute />}*/}
							</Suspense>
							<Troubleshoot />
						</main>
						
						{/*<SupportActions/>*/}
						<Footer />


					</div>

					
					<Popups />
					{ app.state.loaded && app.dvc.org.type=='pharm' && !document.location.href.startsWith('http://localhost:9011/') && 
						<IdleScreen /> 
					}
					<Confirm/>
						{ /* 
					<SMSVerification />
						*/ }

				</React.Fragment>

	}

}
